declare var wp: any;

namespace TotalContest {
    import Component = TotalCore.Common.Component;

    @Component('components.totalcontest', {
        templateUrl: 'feedback-collector-component-template',
        bindings: {}
    })
    class FeedbackCollectorComponent {
        public visible = false;
        public score = 0;
        public email = '';
        public comment = '';

        public isScore(score) {
            return this.score == score;
        }

        public setScore(score) {
            return this.score = score;
        }

        public isCommentNeeded() {
            return this.score > 0 && this.score < 7;
        }

        public constructor(private $scope) {
            if (this.shouldDisplayFeedbackForm()) {
                setTimeout(() => {
                    this.$scope.$applyAsync(() => {
                        this.visible = true;
                    });
                }, 1000);
            }
        }

        private STATE_KEY = 'totalcontest-marketing';

        private _state: any = angular.merge({
                feedback: {
                    collected: false,
                    lastRequestAt: null,
                }
            },
            JSON.parse(localStorage.getItem(this.STATE_KEY)) || {}
        );

        get state() {
            return this._state;
        }

        set state(state) {
            localStorage.setItem(this.STATE_KEY, JSON.stringify(state));
        }

        refreshState() {
            this.state = this.state;

            return this.state;
        }

        shouldDisplayFeedbackForm() {
            if (this.state.feedback.lastRequestAt === null) {
                this.state.feedback.lastRequestAt = Date.now();
                this.refreshState();
            }

            return !this.state.feedback.collected &&
                (Date.now() - this.state.feedback.lastRequestAt) > (7 * 24 * 60 * 60 * 1000);
        }

        markFeedbackAsCollected() {
            wp.ajax.send({
                url: window['totalcontestAjaxURL'],
                data: {
                    action: 'totalcontest_nps',
                    nps: {
                        score: this.score,
                        email: this.email,
                        comment: this.comment
                    }
                },
            });

            this.visible = false;
            this.state.feedback.collected = true;
            this.state.feedback.lastRequestAt = Date.now();
            this.refreshState();
        }

        postponeFeedback() {
            this.visible = false;
            this.state.feedback.lastRequestAt = Date.now();
            this.refreshState();
        }
    }
}
